module.exports = __webpack_public_path__ + "static/media/TN-Men-Shoes-v2.0.aec3b772.svg";